// Parses a date string (YYYY-MM-DD or ISO 8601) as a local-time Date,
// preventing the UTC-midnight → previous-day shift that occurs when the
// cloud server (UTC) serializes mysql2 Date objects.
export function parseLocalDate(str) {
  if (!str) return new Date(NaN);
  const [y, m, d] = String(str).slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d);
}
